import { useEffect } from "react";

export interface PlayableVideo {
  title: string;
  videoUrl: string;
  cover: string;
}

interface VideoModalProps {
  video: PlayableVideo | null;
  onClose: () => void;
}

export default function VideoModal({ video, onClose }: VideoModalProps) {
  useEffect(() => {
    if (!video) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [video, onClose]);

  if (!video) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/70 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="w-full max-w-3xl overflow-hidden rounded-xl bg-background-50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-4 border-b border-background-200 px-4 py-3">
          <h3 className="truncate font-heading text-sm font-bold text-foreground-950 md:text-base">
            {video.title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-primary-600"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <div className="aspect-video w-full bg-foreground-950">
          <video
            key={video.videoUrl}
            src={video.videoUrl}
            poster={video.cover}
            controls
            autoPlay
            playsInline
            className="h-full w-full"
          >
            <track kind="captions" />
            您的浏览器暂不支持视频播放，请更换浏览器后再试。
          </video>
        </div>
        <p className="px-4 py-3 text-xs text-foreground-500">
          视频为前端演示播放，实际播放效果取决于网络与浏览器。
        </p>
      </div>
    </div>
  );
}